import React from 'react';
import Navigation from './Navigation';
import PullToRefresh from './PullToRefresh';
export default function Layout({ children }: { children: React.ReactNode }) {
  return <div className="ff-app-shell mobile-safe-area">
    <a className="ff-skip-link" href="#finflow-content">Skip to content</a>
    <Navigation />
    <div className="ff-app-content" id="finflow-content" tabIndex={-1}>
      <PullToRefresh>{children}</PullToRefresh>
    </div>
  </div>;
}
